<lib-input-wrapper [ionItemWrap]="ionItemWrap">
    <div [formGroup]="form">
        <ion-input
            #input
            (ionBlur)="onBlur($event)"
            (ionFocus)="onFocus($event)"
            (ionInput)="onInput($event)"
            [attr.aria-label]="label"
            [autocomplete]="autocomplete"
            [debounce]="debounce"
            [errorText]="errorText"
            [formControlName]="controlName || null"
            [helperText]="helperText"
            [inputmode]="inputmode"
            [label]="label"
            [max]="max"
            [maxlength]="maxlength"
            [min]="min"
            [name]="name"
            [ngClass]="{
                'has-error': (submitAttempt && !form.get(controlName)?.valid) || errorText || errorBorder,
                'input-password': type === 'password',
                'input-readonly': readonly
            }"
            [pattern]="pattern"
            [placeholder]="placeholder"
            [readonly]="readonly"
            [required]="required"
            [type]="type"
            class="input input-text"
            labelPlacement="stacked">
            <ion-input-password-toggle
                *ngIf="type === 'password'"
                [hideIcon]="passwordHideIcon"
                [showIcon]="passwordShowIcon"
                class="input-password-toggle"
                color="dark"
                slot="end" />
            <ng-content select="[slot]"></ng-content>
        </ion-input>

        <div
            *ngIf="
                form.get(controlName) &&
                form.get(controlName)?.errors &&
                (submitAttempt || (displayValidationErrorsOnInput && form.get(controlName)?.dirty))
                && label
            ">
            <ion-text color="danger">
                <p *ngIf="form.get(controlName)?.errors?.['required']" class="text-danger text-midsmall">
                    {{ label.replace('*', '') }} is required.
                </p>
                <p *ngIf="form.get(controlName)?.errors?.['minlength']" class="text-danger text-midsmall">
                    {{ label.replace('*', '') }} must be
                    {{ form.get(controlName)?.errors?.['minlength'].requiredLength }} characters or more.
                </p>
                <p *ngIf="form.get(controlName)?.errors?.['maxlength']" class="text-danger text-midsmall">
                    {{ label.replace('*', '') }} must be less than or equal to
                    {{ form.get(controlName)?.errors?.['minLength'].requiredLength }} characters.
                </p>
                <p *ngIf="form.get(controlName)?.errors?.['pattern']" class="text-danger text-midsmall">
                    Please enter an {{ label.replace('*', '') }}.
                </p>
            </ion-text>
        </div>

        <ng-content select="[formMessages]"></ng-content>

        <div class="invalid-text">
            <ng-content select="[formErrorMessages]"></ng-content>
        </div>
    </div>
</lib-input-wrapper>
